/**
 * Stable CSS class names for E2E — Grow management.
 */
export const GROW = {
    page: 'grow-management-page',
    breadcrumbSection: 'grow-management-page__breadcrumb-section',
    loadingSection: 'grow-management-page__loading-section',
    contentSection: 'grow-management-page__content-section',

    listSection: 'grow-management-page__list-section',
    listToolbar: 'grow-management-page__list-toolbar',
    listTitle: 'grow-management-page__list-title',
    inputButtonExportExcel: 'grow-management-page-input--button-export-excel',
    gridWrap: 'grow-management-page__grid-wrap',

    datagridLabelStatus: 'grow-management-page-datagrid-label--status',
    inputSwitchStatusReadonly: 'grow-management-page-input--switch-status-readonly',
    datagridCellBufferBadge: 'grow-management-page-datagrid-cell--buffer-badge',
    inputButtonRowActions: 'grow-management-page-input--button-row-actions',
    inputMenuItemEdit: 'grow-management-page-input--menu-item-edit',
    inputMenuItemViewLogs: 'grow-management-page-input--menu-item-view-logs',

    editModalContent: 'grow-management-edit-modal__content',
    editModalWarehouseRow: 'grow-management-edit-modal__warehouse-code-row',
    editModalStatusRow: 'grow-management-edit-modal__store-status-row',
    inputSwitchStoreStatus: 'grow-management-edit-modal-input--switch-store-status',
    editModalBufferRow: 'grow-management-edit-modal__buffer-row',
    inputNumberBufferSize: 'grow-management-edit-modal-input--number-buffer-size',
    editModalDailyLimitRow: 'grow-management-edit-modal__daily-limit-row',
    inputNumberDailyLimit: 'grow-management-edit-modal-input--number-daily-limit',
    editModalStockSourceRow: 'grow-management-edit-modal__stock-source-row',
    inputSelectStockSource: 'grow-management-edit-modal-input--select-stock-source',
    inputButtonModalSave: 'grow-management-edit-modal-input--button-save',

    logModalBody: 'grow-management-log-modal__body',
    logModalLoading: 'grow-management-log-modal__loading',
    logModalGridWrap: 'grow-management-log-modal__grid-wrap',
    logDatagridCellMessage: 'grow-management-log-modal-datagrid-cell--message',
    logModalFooter: 'grow-management-log-modal__footer',
    inputButtonLogClose: 'grow-management-log-modal-input--button-close',
} as const;

export const growCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
